module.exports = __webpack_public_path__ + "img/not-found.b1465665.svg";